import { useLazyGetSensorsTabQuery } from "store/api/devicesApi"
import { useLazyGetOrderSensorsQuery, useLazyGetSensorStatusesQuery } from "store/api/widgetsApi"

import { convertSensorsTabToTableRows } from "utils/convertData"
import { WidgetsRow } from "layouts/WidgetsLayout/WidgetsRow"
import { SensorsPageContent } from "components/sensorsTable/SensorsPageContent"
import { useSensorsPage } from "components/sensorsTable/useSensorsPage"
import { WidgetOrderedSensors } from "components/widgets/WidgetOrderedSensors"
import { WidgetSensorStatuses } from "components/widgets/WidgetSensorStatuses"

const ContractorSensorsPage = () => {
  const props = useSensorsPage({
    useLazyQuery: useLazyGetSensorsTabQuery,
    convertData: convertSensorsTabToTableRows,
    listName: "contractor_sensors_list",
    tableName: "contractor-sensors",
  })

  return (
    <>
      <WidgetsRow>
        <WidgetOrderedSensors useLazyQuery={useLazyGetOrderSensorsQuery} />
        <WidgetSensorStatuses useLazyQuery={useLazyGetSensorStatusesQuery} />
      </WidgetsRow>
      <SensorsPageContent {...props} />
    </>
  )
}

export default ContractorSensorsPage
